/** Marketplace taxonomy/configuration paths; separate from public offer discovery. */
export const marketplaceConfigurationPaths = {
  public: () => '/marketplace/configuration',
  manage: () => '/marketplace/configuration/manage',
};

export default marketplaceConfigurationPaths;
